var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholderInterface(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "placeholder_interface") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "placeholder_interface",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFA367",
    x: 8,
    y: 8,
    width: 84,
    height: 84,
    rx: 21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    stroke: "#979797",
    x: 8.5,
    y: 8.5,
    width: 83,
    height: 83,
    rx: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.828,57.884 L53.828,55.908 C53.9666667,54.868 54.3046667,54.0013333 54.842,53.308 C55.3793333,52.6146667 55.9946667,51.9993333 56.688,51.462 C57.3813333,50.9246667 58.118,50.3873333 58.898,49.85 C59.678,49.3126667 60.3886667,48.6626667 61.03,47.9 C61.6713333,47.1373333 62.2086667,46.2186667 62.642,45.144 C63.0753333,44.0693333 63.292,42.7 63.292,41.036 C63.292,40.0306667 63.0753333,38.9473333 62.642,37.786 C62.2086667,36.6246667 61.4893333,35.5413333 60.484,34.536 C59.4786667,33.5306667 58.1526667,32.69 56.506,32.014 C54.8593333,31.338 52.8053333,31 50.344,31 C48.4373333,31 46.7126667,31.3206667 45.17,31.962 C43.6273333,32.6033333 42.31,33.496 41.218,34.64 C40.126,35.784 39.2766667,37.136 38.67,38.696 C38.0633333,40.256 37.7426667,41.972 37.708,43.844 L45.352,43.844 C45.352,42.908 45.456,42.0326667 45.664,41.218 C45.872,40.4033333 46.1926667,39.6926667 46.626,39.086 C47.0593333,38.4793333 47.614,37.994 48.29,37.63 C48.966,37.266 49.772,37.084 50.708,37.084 C52.0946667,37.084 53.178,37.4653333 53.958,38.228 C54.738,38.9906667 55.128,40.1693333 55.128,41.764 C55.1626667,42.7 54.998,43.48 54.634,44.104 C54.27,44.728 53.7933333,45.3 53.204,45.82 C52.6146667,46.34 51.9733333,46.86 51.28,47.38 C50.5866667,47.9 49.928,48.5153333 49.304,49.226 C48.68,49.9366667 48.134,50.7946667 47.666,51.8 C47.198,52.8053333 46.912,54.0533333 46.808,55.544 L46.808,57.884 L53.828,57.884 Z M54.244,69.012 L54.244,61.004 L46.08,61.004 L46.08,69.012 L54.244,69.012 Z",
    id: "?",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderInterface);
export default __webpack_public_path__ + "static/media/placeholder_interface.e30283ae26bf872d44094de85c320381.svg";
export { ForwardRef as ReactComponent };